import { render, staticRenderFns } from "./file-input-quarternary.vue?vue&type=template&id=49489c8f&scoped=true"
import script from "./file-input-quarternary.vue?vue&type=script&lang=js"
export * from "./file-input-quarternary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49489c8f",
  null
  
)

export default component.exports